export default __webpack_public_path__ + "static/media/Group9165.fe6eb6b7.svg";